import type { AgreementSummary, ClientStampedSigning } from 'types';

type AgreementSigningState = Pick<AgreementSummary, 'signed' | 'signing' | 'signing_blocked'>;

/**
 * Unsigned summaries with no signing metadata are intentionally unavailable.
 * Signed summaries also have `signing: null`, so `signed` must be checked first.
 */
export const isAgreementSigningBlocked = (
    summary: AgreementSigningState | null | undefined
): boolean =>
    Boolean(
        summary && !summary.signed && (summary.signing_blocked === true || summary.signing === null)
    );

export const isAgreementSigningAvailable = (
    summary: AgreementSigningState | null | undefined
): boolean => Boolean(summary && !summary.signed && !isAgreementSigningBlocked(summary));

/**
 * Coordinates the client stamps the PDF at (pdf-lib flow). `null` when the
 * backend embeds the signature itself (`server_embedded`) or once signed.
 */
export const getClientStampedSigning = (
    summary: AgreementSummary | null | undefined
): ClientStampedSigning | null =>
    summary?.signing?.method === 'client_stamped' ? summary.signing : null;

/** `client_signature` multipart part expected by `POST /agreement/<id>`. */
export const toClientSignatureHtml = (signatureDataUrl: string): string =>
    `<img src="${signatureDataUrl}" alt="Client Signature" />`;
